import React from 'react'
import Box from '@material-ui/core/Box'
import { Helmet } from 'react-helmet'

import { Header, Heading, Main, Typography } from '~/components'

export const VisitUnavailable: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Visit Unavailable</title>
      </Helmet>
      <Header />
      <Main p={3}>
        <Heading>Let&apos;s make sure we don&apos;t miss you.</Heading>
        <Box mt={2}>
          <Typography>
            It looks like you might be a little early or late for your visit. You can join from a
            phone or computer starting closer to your appointment. This link expires shortly after
            it ends.
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography>
            To join the visit, go back to your email confirmation and click to join. If you think
            this might be in error, double check the time and date or chat with us in the app for
            additional help.
          </Typography>
        </Box>
      </Main>
    </>
  )
}
